<div class="content right" ngDraggable [handle]="DragHandle" style="z-index: 999;">
    <!-- Close icon -->
    <div class="draggableArea" #DragHandle>
      <i class="fa fa-bars menu"></i>
      <span class="title">Drag & Drop Document using this header</span>
      <div class="closePreview" (click)="expandArea()" style="right: 35px;">
        <i class="fa fa-expand expand"></i>
      </div>
      <div class="closePreview" (click)="closePreview()">
        <i class="fa fa-close"></i>
      </div>
    </div>

    <div class="content-wrapper" [ngClass]="{'medium': size === PreviewSize.MEDIUM,
                  'large': size === PreviewSize.LARGE}">

      <div class="modal-header">
        <h4 class="modal-title pull-left mt-2">Site Visit Email</h4>
        <div class="reset mt-2" (click)="resetTemplate()">Reset to Initial Template</div>
      </div>

      <div class="modal-body">
        <div class="row">
          <div class="col-12">
            <h5 class="text-center mb-0">You are about to send <u>Site Visit</u> Email</h5>
            <p class="text-center">a Site Visit notification will be sent to:</p>

            <div class="header-wrapper" *ngIf="getSiteVisitRecipient(); let user">
              <div class="user">
                <ngx-avatar name="{{user.NAME}}" size="48"></ngx-avatar>
                <div class="user-name">{{user.NAME}}</div>
                <div class="user-email" *ngIf="user.EMAIL">
                  <a href="mailto:{{user.EMAIL}}">{{user.EMAIL}}</a>
                </div>
                <div class="address-wrapper">
                  <span class="label">Address:</span>
                  <span class="address">{{user.getFullAddress()}}</span>
                </div>

                <div class="address-wrapper" *ngIf="user.ENG_ADDRESS">
                  <span class="label">Engagement Letter Address:</span>
                  <span class="address">{{user.ENG_ADDRESS}}</span>
                </div>
              </div>

              <div class="at">at</div>

              <div class="company">
                {{user.CLIENT.COMPANY_NAME}}
              </div>
            </div>

          </div>
        </div>

        <!-- Site Visit Date Picker -->
        <div class="site-visit-date mt-2">
          <label class="rbv-label">Site Visit Date:</label>
          <input type="text"
                 class="form-control rounded-0"
                 placeholder="MM/DD/YYYY"
                 bsDatepicker
                 [(ngModel)]="siteVisitDate"
                 [bsConfig]="{dateInputFormat: 'MM/DD/YYYY', showWeekNumbers: false}"
                 (ngModelChange)="onSiteVisitDateChange()"
                 readonly>
        </div>

        <div class="recipients mt-2">
          <div class="row">
            <div class="col-md-12">
              <label class="rbv-label">Recipient to:</label>
              <input-search #recipientField [preset]="userTypes" [provider]="userProvider" placeholder="Select Recipient"
                            [presetHeader]="'Client User'" (multipleValueChanged)="recipientChanged($event)"
                            [multiple]="true" [typeEmail]="true" [refresh]="true" [parent-id]="currentReport.CLIENT?.ID"></input-search>
            </div>
          </div>

          <div class="row" style="margin-top: 5px;">
            <div class="col-md-12">
              <label class="rbv-label">CC:</label>
              <input-search #ccField [preset]="userTypes" [provider]="userProvider" placeholder="Select CC Recipients"
                            [presetHeader]="'Client Users'" [multiple]="true" [typeEmail]="true"
                            (multipleValueChanged)="ccChanged($event)"
                            [parent-id]="currentReport.CLIENT?.ID"></input-search>
            </div>
            <div class="col-md-12 mt-2">
              <label class="rbv-label">BCC:</label>
              <input-search #bccField [preset]="userTypes" [provider]="userProvider" placeholder="Select BCC Recipients"
                            [presetHeader]="'Client Users'" [multiple]="true" [typeEmail]="true"
                            (multipleValueChanged)="bccChanged($event)"
                            [parent-id]="currentReport.CLIENT?.ID"></input-search>
            </div>
          </div>
        </div>

        <div class="subject mt-2">
          <label class="rbv-label">Subject:</label>
          <input type="text" name="mailSubject" class="form-control rounded-0" [(ngModel)]="htmlSubject">
        </div>

        <div class="row mt-2" id="SITE_VISIT_EMAIL_MANUAL">
          <div class="col-12">
            <label>Site Visit Email:</label>
            <quill-editor [styles]="editorStyle" name="SITE_VISIT_EMAIL" [(ngModel)]="htmlContent"
            [modules]="quillModules" (onContentChanged)="onContentChanged($event)"></quill-editor>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <div class="footer-wrapper">
          <div class="warnings">
            <div class="button-wrapper d-flex">
              <!-- Add any preview or download buttons here if needed -->
            </div>
          </div>

          <div class="actions">
            <button class="btn btn-rbv default" (click)="closeModal()" [disabled]="isLoading">Cancel</button>
            <button class="btn btn-rbv" (click)="onConfirm()" *ngIf="!isLoading">Send Site Visit Email</button>
            <button class="btn btn-rbv" disabled *ngIf="isLoading">
              <span class="loading-icon-small"></span> Processing
            </button>
          </div>
        </div>
      </div>
    </div>
</div>